import { InputTitle } from 'components/input/InputTitle';
import { Button, Spacing, TextInput, Typography } from 'enable-ui';
import { InputColor } from 'enums';

import { TitleLink } from '../styles';

import { PATH } from 'constants/path';

import { useLoginController } from '../core';

const LoginPage = () => {
  const {
    account,
    password,
    handleChange,
    handleSubmit,
    passwordStatus,
    disabled,
    emailStatus,
    navigation,
  } = useLoginController();

  return (
    <div>
      <Spacing spacing="4xl" placement="bottom" type="margin">
        <Typography
          variant="h4"
          weight={500}
          style={{
            textAlign: 'center',
            fontSize: '26px',
            lineHeight: '36px',
          }}
        >
          Log In
        </Typography>
      </Spacing>
      <Spacing spacing="xl" placement="bottom" type="margin">
        <InputTitle title="Email" style={{ color: '#222222' }} />
        <TextInput
          containerStyle={{
            maxWidth: 'auto',
          }}
          name="account"
          value={account}
          onChange={handleChange}
        />
      </Spacing>
      <Spacing>
        <InputTitle title="Password" style={{ color: '#222222' }} />
        <TextInput
          name="password"
          type="password"
          value={password}
          onChange={handleChange}
          autoComplete="new-password"
          helperText={passwordStatus.helperText}
          color={passwordStatus.color}
          containerStyle={{
            maxWidth: 'auto',
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              passwordStatus.color === InputColor.Success &&
                emailStatus.color === InputColor.Success &&
                handleSubmit();
            }
          }}
        />
      </Spacing>

      <Spacing spacing="4xl" placement={'top'} type="margin">
        <Button
          variant="contained"
          color="primary"
          type="submit"
          size="large"
          style={{
            width: '100%',
            fontSize: '18px',
            lineHeight: '26px',
            fontWeight: 600,
          }}
          disabled={disabled}
          onClick={() => handleSubmit()}
        >
          Login
        </Button>
      </Spacing>

      <Spacing spacing="xl" placement="top" type="margin" style={{ textAlign: 'center' }}>
        <TitleLink
          onClick={() => navigation(PATH.FORGOT_PASSWORD)}
          style={{
            margin: 0,
            width: 'fit-content',
          }}
          color="#383ECD"
        >
          Forgot your password?
        </TitleLink>
      </Spacing>
    </div>
  );
};

export default LoginPage;
